export default __webpack_public_path__ + "static/media/ic-sm-cutandcarry.b0da39ad.svg";